
import Sapling from '@/models/sapling.model';
import { GeneticsMap } from '@/services/crossbreeding-service/models';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SaplingInputHighlights extends Vue {
  @Prop({ type: Object }) readonly highlightedMap: GeneticsMap;
  @Prop({ type: String }) readonly inputString: string;

  get crossbreedingHighlightsPositions() {
    let positions: { position: number; saplingGeneString: string; isBase: boolean }[] = [];
    if (this.highlightedMap && this.inputString) {
      positions = [
        ...positions,
        ...this.calculatePositions(this.highlightedMap.crossbreedingSaplings).map((positionData) => ({
          ...positionData,
          isBase: false
        }))
      ];

      if (this.highlightedMap.baseSapling) {
        positions = [
          ...positions,
          ...this.calculatePositions([this.highlightedMap.baseSapling]).map((positionData) => ({
            ...positionData,
            isBase: true
          }))
        ];
      }
    }
    return positions;
  }

  get baseHighlightsPositions() {
    if (this.highlightedMap && this.highlightedMap.baseSapling && this.inputString) {
      return this.calculatePositions([this.highlightedMap.baseSapling]);
    }
    return [];
  }

  calculatePositions(saplingList: Sapling[]) {
    const positions: { position: number; saplingGeneString: string }[] = [];
    const inputSaplingStrings = this.inputString.trim().split(/\r?\n/);
    saplingList.forEach((sapling) => {
      const saplingGeneString = sapling.genes.map((gene) => gene.type.toString()).join('');
      const position = inputSaplingStrings.indexOf(saplingGeneString);
      if (position !== -1 && positions.map((positionObj) => positionObj.position).indexOf(position) === -1) {
        positions.push({ position, saplingGeneString: saplingGeneString });
      }
    });
    return positions;
  }
}
